"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _JumpNative = _interopRequireDefault(require("@/components/JumpNative"));
var _index = _interopRequireDefault(require("@/components/Tinymce/index"));
var _luckyWheelApi = require("@/api/luckyWheelApi");
var _orderListApi = require("@/api/orderListApi");
var _static = require("@/views/orderList/order/static");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var DEFAULT_JUMP_TIP = '用户在大转盘未购买指定商品时，点击【去购买】跳转到这里配置的页面。';
var _RULE_CONTENT_MAX = 1000;
var defaultFormData = function defaultFormData() {
  return {
    wheelBackgroundImage: '',
    participateCondition: 1,
    creditOrderStatus: 2,
    orderTypes: [1],
    buyJumpValue: '',
    perOrderDrawTimes: '2',
    maxDrawTimes: '',
    ruleContent: ''
  };
};
var _default = exports.default = {
  name: 'LuckyWheelSetting',
  components: {
    JumpNative: _JumpNative.default,
    Tinymce: _index.default
  },
  data: function data() {
    var _this = this;
    return {
      pageLoading: false,
      ruleSaving: false,
      jumpLinkTip: DEFAULT_JUMP_TIP,
      formData: defaultFormData(),
      creditStatusOptions: _static.orderStateOption.filter(function (item) {
        return item.value === 2 || item.value === 6;
      }),
      orderTypeOptions: [],
      tinymceToolbar: ['bold italic underline strikethrough alignleft aligncenter alignright bullist numlist'],
      rules: {
        wheelBackgroundImage: [{
          required: true,
          message: '请选择！',
          trigger: 'change'
        }],
        participateCondition: [{
          required: true,
          message: '请选择！',
          trigger: 'change'
        }],
        creditOrderStatus: [{
          required: true,
          message: '请选择！',
          trigger: 'change'
        }],
        orderTypes: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择！',
          trigger: 'change'
        }],
        buyJumpValue: [{
          required: true,
          message: '请选择！',
          trigger: 'change'
        }],
        perOrderDrawTimes: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value || Number(value) < 1) return callback(new Error('请输入！'));
            callback();
          },
          trigger: 'blur'
        }],
        maxDrawTimes: [{
          required: true,
          validator: function validator(rule, value, callback) {
            if (!value || Number(value) < 1) return callback(new Error('请输入！'));
            callback();
          },
          trigger: 'blur'
        }],
        ruleContent: [{
          validator: function validator(rule, value, callback) {
            var text = _this.stripHtml(value);
            if (!text) return callback(new Error('请输入！'));
            if (text.length <= _RULE_CONTENT_MAX) return callback();
            callback(new Error('规则说明不能超过1000字符'));
          },
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  computed: {
    RULE_CONTENT_MAX: function RULE_CONTENT_MAX() {
      return _RULE_CONTENT_MAX;
    },
    ruleCharCount: function ruleCharCount() {
      return this.stripHtml(this.formData.ruleContent).length;
    }
  },
  created: function created() {
    this.loadOrderTypeOptions();
    this.loadConfig();
  },
  methods: {
    loadOrderTypeOptions: function loadOrderTypeOptions() {
      var _this2 = this;
      return (0, _orderListApi.getOrderTypes)().then(function (res) {
        _this2.orderTypeOptions = res || [];
      }).catch(function () {
        _this2.orderTypeOptions = [];
      });
    },
    stripHtml: function stripHtml(html) {
      if (!html) return '';
      var div = document.createElement('div');
      div.innerHTML = html;
      div.querySelectorAll('[data-mce-bogus]').forEach(function (el) {
        return el.remove();
      });
      return (div.textContent || div.innerText || '').replace(/[\u200B\u200C\u200D\uFEFF]/g, '').replace(/\u00A0/g, ' ').replace(/[\r\n]+/g, '').trim();
    },
    isJpgOrPng: function isJpgOrPng(item, url) {
      var type = String(item && (item.attType || item.realName || item.name) || '').toLowerCase();
      var src = String(url || '').toLowerCase();
      return /\.(jpe?g|png)(\?|$)/i.test(src) || /(jpe?g|png)/i.test(type);
    },
    onJumpChange: function onJumpChange() {
      if (this.$refs.formRef) this.$refs.formRef.validateField('buyJumpValue');
    },
    onPerOrderDrawTimesInput: function onPerOrderDrawTimesInput(value) {
      this.formData.perOrderDrawTimes = String(value || '').replace(/[^\d]/g, '').slice(0, 5);
    },
    onMaxDrawTimesInput: function onMaxDrawTimesInput(value) {
      this.formData.maxDrawTimes = String(value || '').replace(/[^\d]/g, '').slice(0, 5);
    },
    parseJumpLinkId: function parseJumpLinkId(val) {
      if (val == null || val === '') return null;
      var idPart = String(val).includes('|&|') ? String(val).split('|&|')[0] : String(val);
      var n = Number(idPart);
      return Number.isInteger(n) && n > 0 ? n : null;
    },
    uploadBgImage: function uploadBgImage() {
      var _this3 = this;
      this.$modalUpload(function (img) {
        if (!img || !img[0]) return;
        var item = img[0];
        var url = item.sattDir || item.attDir || item.url || '';
        if (!_this3.isJpgOrPng(item, url)) {
          _this3.$message.error('图片格式仅支持JPG、PNG，请重新上传');
          return;
        }
        _this3.formData.wheelBackgroundImage = url;
        if (_this3.$refs.formRef) _this3.$refs.formRef.validateField('wheelBackgroundImage');
      }, '1', 'system', false, {
        maxSizeKB: 2048,
        maxSizeErrorMsg: '图片大小超过2MB，请重新上传~',
        acceptExts: ['jpg', 'jpeg', 'png'],
        acceptErrorMsg: '图片格式仅支持JPG、PNG，请重新上传',
        bothErrorMsg: '图片大小不超过2MB，格式仅支持JPG、PNG，请重新上传~'
      });
    },
    buildSubmitBody: function buildSubmitBody() {
      var fd = this.formData;
      return {
        participateCondition: Number(fd.participateCondition),
        creditOrderStatus: Number(fd.creditOrderStatus),
        orderTypes: (fd.orderTypes || []).map(Number),
        jumpLinkId: this.parseJumpLinkId(fd.buyJumpValue),
        perOrderDrawTimes: Number(fd.perOrderDrawTimes),
        maxDrawTimes: Number(fd.maxDrawTimes),
        ruleContent: fd.ruleContent || '',
        wheelBackgroundImage: fd.wheelBackgroundImage || ''
      };
    },
    applyConfig: function applyConfig(data) {
      var _this4 = this;
      if (!data) return;
      this.formData = {
        participateCondition: data.participateCondition != null ? Number(data.participateCondition) : 1,
        creditOrderStatus: data.creditOrderStatus != null ? Number(data.creditOrderStatus) : 2,
        orderTypes: Array.isArray(data.orderTypes) && data.orderTypes.length ? data.orderTypes.map(Number) : [1],
        buyJumpValue: data.jumpLinkId != null ? "".concat(data.jumpLinkId, "|&|").concat(data.jumpLinkUrl || '') : '',
        perOrderDrawTimes: data.perOrderDrawTimes != null && data.perOrderDrawTimes !== '' ? String(data.perOrderDrawTimes) : '2',
        maxDrawTimes: data.maxDrawTimes != null && data.maxDrawTimes !== '' ? String(data.maxDrawTimes) : '',
        ruleContent: data.ruleContent || '',
        wheelBackgroundImage: data.wheelBackgroundImage || ''
      };
      this.jumpLinkTip = data.jumpLinkTip || DEFAULT_JUMP_TIP;
      this.$nextTick(function () {
        return _this4.syncJumpNativeValue(data.jumpLinkId);
      });
    },
    syncJumpNativeValue: function syncJumpNativeValue(jumpLinkId) {
      if (jumpLinkId == null) return;
      var lists = this.$refs.jumpNative && this.$refs.jumpNative.jumpLists || [];
      var match = lists.find(function (item) {
        return Number(item.id) === Number(jumpLinkId);
      });
      if (match && match.jumpvalue) {
        this.formData.buyJumpValue = match.jumpvalue;
      }
    },
    loadConfig: function () {
      var _loadConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.pageLoading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _luckyWheelApi.luckyWheelConfigInfoApi)();
            case 2:
              data = _context.v;
              this.applyConfig(data);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
            case 4:
              _context.p = 4;
              this.pageLoading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function loadConfig() {
        return _loadConfig.apply(this, arguments);
      }
      return loadConfig;
    }(),
    validateForm: function validateForm() {
      var _this5 = this;
      return new Promise(function (resolve) {
        _this5.$refs.formRef.validate(function (valid) {
          return resolve(valid);
        });
      });
    },
    handleSave: function () {
      var _handleSave = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var valid, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.n = 1;
              return this.validateForm();
            case 1:
              valid = _context2.v;
              if (valid) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              this.ruleSaving = true;
              _context2.p = 3;
              _context2.n = 4;
              return (0, _luckyWheelApi.luckyWheelConfigSaveApi)(this.buildSubmitBody());
            case 4:
              this.$message.success('保存成功');
              _context2.n = 6;
              break;
            case 5:
              _context2.p = 5;
              _t2 = _context2.v;
            case 6:
              _context2.p = 6;
              this.ruleSaving = false;
              return _context2.f(6);
            case 7:
              return _context2.a(2);
          }
        }, _callee2, this, [[3, 5, 6, 7]]);
      }));
      function handleSave() {
        return _handleSave.apply(this, arguments);
      }
      return handleSave;
    }()
  }
};